import React from 'react';
import { Dialog, FloatingActionButton, RaisedButton } from "material-ui";
import Clear from "material-ui/svg-icons/content/clear";
import { FormattedMessage } from 'react-intl';
const closeIconStyle = {
  position: "absolute",
  top: "8px",
  right: "5px",
  color: "#4f4f4f",
  height: "28px",
  width: "28px",
  cursor: "pointer"
};


export default class PlayAndDownloadDialog extends React.Component {
  handleClose = () => {
    this.props.handleClose()
  };

  handleClick = (withSubtitle = false) => {
    if(this.props.type === 'play') {
      window.open(withSubtitle ? this.props.recording.s3_srt_url : this.props.recording.s3_url, "_blank");
      this.props.handleClose();
    } else {
      this.props.downloadVideo(withSubtitle ? this.props.recording.s3_srt_url : this.props.recording.s3_url);
      this.props.handleClose();
    }
  }
  
  render() {
    return (
      <Dialog
        modal={true}
        open={this.props.open}
        onRequestClose={this.handleClose}
        autoScrollBodyContent={false}
        contentStyle={{
          width: "85%",
          maxWidth: '350px'
        }}
      >
        <Clear onClick={this.props.handleClose} style={closeIconStyle} />
        <div style={{ marginTop: "26px", display: 'flex', flexDirection: 'column' }}>
          <RaisedButton
            backgroundColor="#60d1bd"
            labelStyle={{ color: "#fff" }}
            style={{ marginBottom: '12px' }}
            onClick={() => this.handleClick(true)}
            disabled={!this.props.recording.s3_srt_url}
            label={<FormattedMessage id="roomRecordings.withSubtitle" />}
          />
          <RaisedButton
            onClick={() => this.handleClick()}
            backgroundColor="#60d1bd"
            labelStyle={{ color: "#fff" }}
            label={<FormattedMessage id="roomRecordings.withoutSubtitle" />}
          />
        </div>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// src/components/RoomRecordingsTable/PlayAndDownloadDialog.js